<template>
    <div class="sso">
        <OtButton
            v-if="showBeatport"
            class="sso-button is-fullwidth"
            :title="$t('login.login.sso.beatport.submit.title')"
            @click="useBeatport()"
        >
            {{ $t('login.login.sso.beatport.submit.text') }}
            <i class="oti oti-arrow-right ot-button-icon--right"/>
        </OtButton>

        <OtButton
            v-if="showAnySSO"
            class="other-login-method-action is-text is-small is-brand"
            type="button"
            @click="emitOtherAction"
            :title="$t('login.login.sso.unknown.other_action.title').toString()"
        >
            {{ $t('login.login.sso.unknown.other_action.text') }}
        </OtButton>
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import OtButton from './OtButton.vue';
import {
    combineSingleSignOnActions,
    getSingleSignOnActionOverrides,
    SINGLE_SIGN_ON_ACTION, type SingleSignOnAction,
    type SingleSignOnActionOverrides,
} from '../services/util/signInAction';

@Component({ components: { OtButton } })
export default class SingleSignOn extends Vue {

    @Prop({ default: false, type: Boolean }) showCredentials!: boolean;

    ssoActionOverrides: SingleSignOnActionOverrides = {};

    created() {
        // DD-4E8B - Sign in overrides can only be applied on sso providers which are configured for a whitelabel.
        // If an override is wanted for a default action, the provider must be explicitly configured first.
        this.ssoActionOverrides = getSingleSignOnActionOverrides();
    }

    get showAnySSO(): boolean {
        return !this.showCredentials && [
            this.showBeatport,
        ].some(Boolean);
    }

    get showBeatport(): boolean {
        // DD-4E87 - The beatport sso button is hidden by default, unless specifically shown.
        const combined = combineSingleSignOnActions(
            this.$whitelabel.login.sso?.beatport?.action ?? '',
            this.ssoActionOverrides['login_sso[beatport]'],
        );

        if (!combined) {
            // When combined is falsey, the button should only be shown if the config action is set to auto-redirect.
            // This allows the no-auto-redirect case to disable auto-redirecting without hiding the button altogether.
            return this.$whitelabel.login.sso?.beatport?.action === SINGLE_SIGN_ON_ACTION.AUTO_REDIRECT;
        }

        const showActions: SingleSignOnAction[] = [
            SINGLE_SIGN_ON_ACTION.AUTO_REDIRECT,
            SINGLE_SIGN_ON_ACTION.SHOW,
        ];

        return showActions.includes(combined);
    }

    useBeatport(): void {
        this.$emit('use-sso', { provider: 'beatport' });
    }

    emitOtherAction(): void {
        this.$emit('use-other');
    }

}
</script>

<style lang="scss" scoped>
.sso {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--ot-spacing-default);

    .other-login-method-action {
        color: var(--ot-color-core-brand);
    }
}
</style>
